import classNames from 'classnames';
import { type ComponentPropsWithoutRef, memo } from 'react';

export type ContentCollectionSidebarSeparatorProps = ComponentPropsWithoutRef<'div'>;

export const ContentCollectionSidebarSeparator = memo(
  ({ className, ...restOfProps }: ContentCollectionSidebarSeparatorProps) => {
    return <div className={classNames('h-px w-full ads:bg-ads-gray-4 bg-gray-4', className)} {...restOfProps} />;
  },
);

ContentCollectionSidebarSeparator.displayName = 'ContentCollectionSidebarSeparator';
